export default "__VITE_ASSET___6p4KDCp__"